var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtensionLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49039 23.9882C5.5674 24.386 5.91714 24.6735 6.32411 24.6735H9.27822C9.74714 24.6735 10.1273 24.2951 10.1273 23.8283C10.1273 23.3615 9.74714 22.9832 9.27822 22.9832H7.02517L6.96895 22.6928H9.82502C10.284 22.6928 10.6598 22.3297 10.6737 21.8731C10.7656 18.8418 11.9803 16.8543 13.277 14.8439C13.3269 14.7666 13.377 14.6891 13.4272 14.6115C14.6734 12.6842 16 10.6324 16 7.70685C16 5.12018 14.9691 3.16399 13.4011 1.86939C11.8546 0.592615 9.83821 0 7.89348 0C4.16622 0 0 2.69728 0 7.79173C0 10.4637 1.20841 12.7904 2.36928 14.7822C2.54724 15.0875 2.7226 15.3824 2.89345 15.6698C3.29606 16.3468 3.67369 16.9819 4.00154 17.6126C4.46442 18.5029 4.77803 19.2953 4.8793 20.0311C4.93753 20.4542 5.30369 20.7676 5.73266 20.7615C6.16164 20.7554 6.51863 20.4317 6.56467 20.0071C6.63886 19.3228 7.00923 18.5088 7.62554 17.5472C8.15048 16.7281 8.80136 15.879 9.48933 14.9814C9.60142 14.8352 9.71449 14.6877 9.82817 14.5388C10.6249 13.4953 11.4454 12.3916 12.0648 11.2827C12.6814 10.1787 13.1453 8.99005 13.1453 7.77759C13.1453 6.30807 12.5854 5.0596 11.6113 4.18578C10.6461 3.32002 9.33188 2.87201 7.89348 2.87201C5.05593 2.87201 2.85469 5.14304 2.85469 7.77759C2.85469 8.54871 3.0097 9.70624 3.42331 10.702C3.81781 11.6517 4.60822 12.7963 6.03296 12.7963C6.72841 12.7963 7.29807 12.5441 7.72147 12.1187C8.1217 11.7167 8.34701 11.2057 8.48098 10.7381C8.73102 9.86535 8.72933 8.88567 8.72844 8.36959C8.72839 8.34052 8.72834 8.31293 8.72834 8.28691C8.72834 7.82015 8.3482 7.44176 7.87928 7.44176C7.41036 7.44176 7.03022 7.82015 7.03022 8.28691L7.03022 8.32481C7.03033 8.86786 7.03047 9.63752 6.84796 10.2746C6.75646 10.5939 6.63825 10.8054 6.5152 10.929C6.41534 11.0294 6.28197 11.106 6.03296 11.106C5.69659 11.106 5.3224 10.8501 4.99258 10.0561C4.68186 9.30808 4.55282 8.3788 4.55282 7.77759C4.55282 6.0829 5.98741 4.56231 7.89348 4.56231C8.98312 4.56231 9.8703 4.8995 10.4745 5.44145C11.0697 5.97534 11.4472 6.75708 11.4472 7.77759C11.4472 8.57411 11.137 9.46523 10.5806 10.4613C10.027 11.4524 9.2755 12.4691 8.47618 13.516C8.36683 13.6592 8.25642 13.8032 8.14559 13.9477C7.46116 14.8403 6.76061 15.7539 6.19394 16.6381C6.0443 16.8715 5.9002 17.1085 5.76553 17.3482C5.68352 17.1762 5.59787 17.0053 5.50971 16.8357C5.15843 16.16 4.74181 15.4593 4.32822 14.7637C4.16291 14.4857 3.99809 14.2085 3.83812 13.934C2.68399 11.9538 1.69812 9.97245 1.69812 7.79173C1.69812 3.83157 4.88878 1.6903 7.89348 1.6903C9.51357 1.6903 11.1259 2.18706 12.317 3.17041C13.4864 4.13592 14.3019 5.61058 14.3019 7.70685C14.3019 10.1284 13.2215 11.8025 11.9324 13.8C11.9044 13.8434 11.8763 13.887 11.8481 13.9307C10.6363 15.8094 9.31298 17.9277 9.02663 21.0025H5.94064C5.68731 21.0025 5.44722 21.1151 5.28592 21.3095C5.12463 21.5039 5.05898 21.7599 5.10692 22.0075L5.49039 23.9882Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05807 25.0379C9.05807 25.8117 8.45242 26 7.70529 26C6.95816 26 6.35251 25.8117 6.35251 25.0379H9.05807Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.691 9.28855C10.7491 9.14249 10.6772 8.97722 10.5305 8.9194L9.51397 8.5189C9.36723 8.46109 9.2012 8.53262 9.14312 8.67868C9.08504 8.82474 9.15691 8.99001 9.30364 9.04782L10.3202 9.44833C10.4669 9.50614 10.6329 9.4346 10.691 9.28855Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26181 9.49463C5.32747 9.63747 5.49702 9.70029 5.64053 9.63494L6.6347 9.18221C6.77821 9.11686 6.84132 8.94809 6.77567 8.80524C6.71001 8.6624 6.54046 8.59957 6.39695 8.66492L5.40278 9.11766C5.25927 9.18301 5.19616 9.35178 5.26181 9.49463Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76773 7.86133C6.81806 7.71245 6.7376 7.55115 6.58803 7.50105L5.55192 7.15404C5.40235 7.10395 5.2403 7.18403 5.18997 7.33292C5.13965 7.4818 5.2201 7.6431 5.36967 7.69319L6.40579 8.0402C6.55536 8.0903 6.7174 8.01021 6.76773 7.86133Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35105 7.20032C7.49907 7.14586 7.57471 6.98226 7.52 6.83492L7.14074 5.81362C7.08603 5.66628 6.92168 5.59099 6.77366 5.64545C6.62564 5.69991 6.54999 5.86351 6.60471 6.01085L6.98396 7.03215C7.03867 7.17949 7.20302 7.25478 7.35105 7.20032Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42334 7.14449C8.57151 7.19854 8.73565 7.12279 8.78995 6.97529L9.16631 5.95295C9.22061 5.80545 9.14451 5.64207 8.99633 5.58802C8.84816 5.53398 8.68402 5.60973 8.62972 5.75722L8.25336 6.77957C8.19906 6.92706 8.27516 7.09044 8.42334 7.14449Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12326 7.78428C9.19124 7.92604 9.36181 7.9861 9.50422 7.91843L10.4909 7.44962C10.6333 7.38195 10.6936 7.21217 10.6256 7.07041C10.5576 6.92865 10.3871 6.86859 10.2447 6.93626L9.25803 7.40507C9.11561 7.47274 9.05527 7.64252 9.12326 7.78428Z",
    fill: "url(#paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.23109e-8,
    y1: 13.1494,
    x2: 16,
    y2: 13.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1.23109e-8,
    y1: 13.1494,
    x2: 16,
    y2: 13.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1.23109e-8,
    y1: 13.1494,
    x2: 16,
    y2: 13.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1.23109e-8,
    y1: 13.1494,
    x2: 16,
    y2: 13.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 1.23109e-8,
    y1: 13.1494,
    x2: 16,
    y2: 13.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1.23109e-8,
    y1: 13.1494,
    x2: 16,
    y2: 13.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1.23109e-8,
    y1: 13.1494,
    x2: 16,
    y2: 13.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 1.23109e-8,
    y1: 13.1494,
    x2: 16,
    y2: 13.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensionLogo);
export default __webpack_public_path__ + "static/media/extensionLogo.ff8a0ef48d12ea3b6d3c01940fd06e3d.svg";
export { ForwardRef as ReactComponent };